/* eslint-disable @typescript-eslint/naming-convention */
export enum axesEnum {
    x,
    y,
    z
}
